export default __webpack_public_path__ + "static/photo-6-93f36d2d140f877e8255b95036e940ab.jpg";